const NS = 'WoolpollInteractiveGraphBlock';
const CLS = 'woolpollInteractiveGraphBlock';

let d3 = require('d3');

import data from '../model/woolpollInteractiveGraphBlock.json';

export class WoolpollInteractiveGraphBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$levyBtn1 = this.$element.find(`#levyBtn1`);
		this.$levyBtn2 = this.$element.find(`#levyBtn2`);
		this.$levyBtn3 = this.$element.find(`#levyBtn3`);
		this.$levyBtn4 = this.$element.find(`#levyBtn4`);
		this.$btns = this.$element.find(`.${CLS}-btns button`);
		this.$data = data;

		this.margin = {top: 30, right: 30, bottom: 70, left: 60},
		this.width = this.$element.width() - this.margin.left - this.margin.right,
		this.height = 600 - this.margin.top - this.margin.bottom;
 
		this.svg = d3.select(`.woolpollInteractiveGraphBlock-chart`)
		.append("svg")
			.attr("width", this.width + this.margin.left + this.margin.right)
			.attr("height", this.height + this.margin.top + this.margin.bottom)
		.append("g")
			.attr("transform",
		    "translate(" + this.margin.left + "," + this.margin.top + ")");

		this.x = d3.scaleBand()
		.range([ 0, this.width ])
		.domain(this.$data.levyData1.map(function(d) { return d.group; }))
		.padding(0.2);
 
		this.y = d3.scaleLinear()
		.domain([0, 80000])
		.range([ this.height, 0]);

		this.svg.append("g")
		.attr("transform", "translate(0," + this.height + ")")
		.call(d3.axisBottom(this.x))

		this.svg.append("g")
		.attr("class", "myYaxis")
		.call(d3.axisLeft(this.y));
 
		this.update(this.$data.levyData1)
		this.$levyBtn1.on( "click", (e) => {
			this.$btns.css({"background":"#000"});
            this.$levyBtn1.css({"background":"#89d12b"});
			this.update(this.$data.levyData1)
		});
		this.$levyBtn2.on( "click", (e) => {
			this.$btns.css({"background":"#000"});
            this.$levyBtn2.css({"background":"#89d12b"});
			this.update(this.$data.levyData2)
		});
		this.$levyBtn3.on( "click", (e) => {
			this.$btns.css({"background":"#000"});
            this.$levyBtn3.css({"background":"#89d12b"});
			this.update(this.$data.levyData3);
		});
		this.$levyBtn4.on( "click", (e) => {
			this.$btns.css({"background":"#000"});
            this.$levyBtn4.css({"background":"#89d12b"});
			this.update(this.$data.levyData4)
		});

	}

	update(data) {
		this.u = this.svg.selectAll("rect").data(data);
		this.u
		  .enter()
		  .append("rect")
		  .merge(this.u)
		  .transition()
		  .duration(1000)
			.attr("x", d => this.x(d.group))
			.attr("y", d => this.y(d.value))
			.attr("width", this.x.bandwidth())
			.attr("height", d => this.height - this.y(d.value))
			.attr("fill", d => {
			 if (d.group == 'Levy'){
			   return '#2e5f7f'
			 }else if (d.group == 'government'){
			   return '#da7842'
			 }else if (d.group == 'licensing'){
			   return '#34692e'
			 }else if (d.group == 'investment'){
			   return '#489cd0'
			 }else if (d.group == 'other'){
				 return '#93358f'
			 }else if (d.group == 'total'){
				 return '#89d12b'
			 }
			})
	  }
}
